module.exports = fox._r("components/iframe/images/promo-iframe-comix-320.jpg", __webpack_public_path__ + "components/iframe/images/promo-iframe-comix-320.jpg");


//////////////////
// WEBPACK FOOTER
// ./components/iframe/images/promo-iframe-comix-320.jpg
// module id = 85
// module chunks = 5